import React from 'react';
// Убедитесь, что путь к Landing.css правильный
import './Landing.css';

const SuspenseLoader = () => {
    return (
        <div className="fx">
            <div className="loader">
                <span className="logo" style={{ fontSize: '30px', gap: '12px' }}>
                    <span className="logo-mark" />
                    <span className="logo-mark" />
                    <b>FYNEX</b>
                </span>

                <div className="loader-bar" style={{ position: 'relative' }}>
                    {/* Вместо процентов используем класс для плавной бесконечной анимации */}
                    <i className="infinite-progress" />
                </div>
            </div>
        </div>
    );
};

export default SuspenseLoader;